module.exports = __webpack_public_path__ + "img/instagram.87a41ae6.svg";